// HTTP Service constants
export const EVENT_HTTP_REQUEST_TRANSACTION = 'HTTP_SERVICE:EVENT_HTTP_REQUEST_TRANSACTION';
export const EVENT_HTTP_AUTH_ERROR = 'HTTP_SERVICE:EVENT_HTTP_AUTH_ERROR';
export const EVENT_HTTP_NETWORK_ERROR = 'HTTP_SERVICE:EVENT_HTTP_NETWORK_ERROR';
export const EVENT_HTTP_NETWORK_CANCEL = 'HTTP_SERVICE:EVENT_HTTP_NETWORK_CANCEL';
